import glamorous from 'glamorous';

const FeaturedIcon = glamorous.span(
  ({ theme }) => ({
    width: '1em',
    height: '1em',
    color: theme.color.primary,
  }),
  'ion-ios-star',
);

export default FeaturedIcon;
